import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NbAutocompleteComponent } from '@nebular/theme';

@Component({
  selector: 'ngx-item-searchable',
  templateUrl: './item-searchable.component.html',
  styleUrls: ['./item-searchable.component.scss']
})
export class ItemSearchableComponent implements OnInit {


  @ViewChild('auto') selector: ElementRef<NbAutocompleteComponent<any>>;
  @ViewChild('autoInput') input;

  _originalSelected: any;
  selectedKey: string;
  displayValue: any;
  itemsSource: any[] = [];
  filteredItems: any[] = [];

    @Input('no-items-message')
    noItemsMessage: string;

  @Input()
    getKey: Function;

    @Input()
    renderValue: Function;

    displayHandle;

    @Input()
    set jsonSource(value:string){
      if (value) {
        if (!value.startsWith('../assets/')) {
          value = '../assets/' + value;
        }
        this.httpClient.get(value).subscribe(d => {
          this.itemsSource = d as any[];
          this.filteredItems = this.itemsSource;
        });
      }
    }

    @Input()
    set dataSource(value: any[]){
    //  console.log(`item-selector - cargamos el dataSource ${JSON.stringify(value)}`);

      if (value) {
        this.itemsSource = value;
        this.filteredItems = this.itemsSource;
      }

    }

      @Output() selectedDataChange = new EventEmitter<any>();

    @Input()
    set selectedData(value: any){


        console.log(`item-searchable - Establecemos el valor ${JSON.stringify(value)}`);
        if(null != value) {
          this._originalSelected = value;
          this.displayValue = value;
        }



    }

    constructor(private httpClient:HttpClient,private cdRef: ChangeDetectorRef){
        console.log("Construido");
      }

    getId(item: any): string {
      if(this.getKey != undefined){
        return this.getKey(item);
      } else {
        return item.identifier;
      }
    }

    getValue(item: any): string {
      if(this.renderValue != undefined){
        return this.renderValue(item);
      } else {
        return item.name;
      }
    }


    inputChange(){

      if(this.input.nativeElement.value == ''){
        this.filteredItems = this.itemsSource;
        return;
      }
      this.filteredItems = this.itemsSource.filter( e => this.getValue(e).toUpperCase().includes(this.input.nativeElement.value.toUpperCase()));
      console.log(`Filtereditems count ${this.filteredItems.length}`);
    }
    selectionChange(event: any) {
      console.log(event);

      if(event && event != null) this.selectedDataChange.emit(event);
      this.filteredItems = this.itemsSource;


    }

    onModelChange(event: any){
      console.log(event);
    }


  ngOnInit(): void {
      this.filteredItems = this.itemsSource;
      if(this.renderValue == undefined){
          this.renderValue = this.legacyRenderValue;
      }
  }

  legacyRenderValue(item){
    return item.name;
  }

}
